import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await instance.loginPopup();
      navigate("/workitems");
    } catch (e) {
      console.error(e);
    }
  };

  const handleBypass = () => {
    navigate("/");
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '4rem' }}>
      <h2>Sign in to continue</h2>
      <button onClick={handleLogin} style={{ padding: '0.75rem 2rem', fontSize: '1.1rem', cursor: 'pointer', marginTop: '1rem' }}>
        Sign in with Microsoft
      </button>
      <button onClick={handleBypass} style={{ padding: '0.75rem 2rem', fontSize: '1.1rem', cursor: 'pointer', marginTop: '1rem', background: '#eee', color: '#333', border: '1px solid #ccc' }}>
        Continue without signing in
      </button>
    </div>
  );
}
